import { useState } from 'react'

import { EstablishTeamPanel } from './EstablishTeamPanel'
import { HoldKickoffPanel } from './HoldKickoffPanel'
import { MakeAssignmentsPanel } from './MakeAssignmentsPanel'

const STEPS = ['1. Establish your team', '2. Make assignments', '3. Hold a kickoff'] as const

type StepIndex = 0 | 1 | 2

export const ProjectSetUpTabs = () => {
  const [activeStep, setActiveStep] = useState<StepIndex>(0)
  const handleMenuClick = (index: StepIndex) => {
    setActiveStep(index)
    if (typeof window !== 'undefined' && window.scrollTo) {
      window.scrollTo({ top: 220, left: 0, behavior: 'smooth' })
    }
  }

  return (
    <div className="project-setup-tabs flex flex-col lg:flex-row gap-6 items-start w-full ">
      <div className="project-setup-menu lg:sticky lg:top-[140px] lg:self-start z-[1] flex flex-col gap-3 items-start shrink-0 w-full lg:w-[288px]">
        {STEPS.map((step, index) => (
          <button
            key={step}
            className={`setup-menu-item ${activeStep === index ? 'active' : ''}`}
            onClick={() => handleMenuClick(index as StepIndex)}
          >
            {step}
          </button>
        ))}
      </div>

      <div className="project-setup-panel flex-1">
        {activeStep === 0 && <EstablishTeamPanel />}
        {activeStep === 1 && <MakeAssignmentsPanel />}
        {activeStep === 2 && <HoldKickoffPanel />}
      </div>
    </div>
  )
}
